import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacheairflowComponent } from './simple-icons-apacheairflow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacheairflowComponent ],
    exports:      [ SimpleIconsApacheairflowComponent ],
    bootstrap:    []
})
export class SimpleIconsApacheairflowModule {}
